var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-page"},[_c('div',{staticClass:"container container--xs"},[(_vm.$i18n.locale === 'en')?_c('EnglishContent'):_c('DutchContent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }